import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import type { TransformersSearch } from '~/features/transformers/pages/transformers-page';

const TransformersPage = lazy(() => import('~/features/transformers/pages/transformers-page'));

/**
 * Platform › File Transformers (library + assignments). Super-admin gating is
 * inherited from `/platform`'s `requireSystemAdmin()`; the system-tenant rule is
 * checked in the page so a super admin elsewhere gets the "Switch to Lily AI" state.
 */
export const Route = createFileRoute('/_authenticated/_tenant/platform/transformers/')({
  validateSearch: (search: Record<string, unknown>): TransformersSearch => ({
    ...(search.tab === 'assignments' || search.tab === 'transformers' ? { tab: search.tab } : {}),
    ...(typeof search.subsidiary === 'string' && search.subsidiary !== ''
      ? { subsidiary: search.subsidiary }
      : {}),
    ...(typeof search.assign === 'string' && search.assign !== '' ? { assign: search.assign } : {}),
  }),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <TransformersPage />
    </Suspense>
  ),
});
